import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';

import { ModalActions } from '../../../realize_overrides/stores/modal_store';

@mixin.decorate(window.TooltipMixin)
@mixin.decorate(window.CssClassMixin)
export default class Label extends React.Component {
	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		active: PropTypes.bool,
		onClick: PropTypes.func,
		required: PropTypes.bool
	};

	static defaultProps = {
		active: false,
		name: '',
		label: '',
		themeClassKey: 'label',
		required: false
	};

	state = {
		isChecked: false,
		className: this.getLabelClassName(this.props)
	};

	componentWillReceiveProps(nextProps) {
		this.setState({
			className: this.getLabelClassName(nextProps)
		});
	};

	componentDidMount() {
		if (this.props.helpText) {
			$(`.tooltipped`).tooltip();
		}
	}

	getLabelClassName(props) {
		let className = this.className();
		if(props.active) {
			className += ' active';
		}

		return className;
	};

	getTooltipText() {
		var lengthStr = this.props.helpText.length;
		var toolTipText = this.props.helpText;
		var positionToolTipText = this.props.position;

		let labelFields = this.props.label !== null && this.props.label !== undefined && this.props.label !== "" ? this.props.label : this.props.name;

		if(labelFields.length <= 3){
			if (lengthStr > 35) {
				toolTipText = this.props.helpText.substr(0, 13) + "...";
			}
		} else {
			if (lengthStr > 35) {
				toolTipText = this.props.helpText.substr(0, 20) + "...";
			}
		}

		return toolTipText;
	}

	showHelpText(e) {
		e.preventDefault();

		setTimeout(function(){
			$(".material-tooltip").hide();
		}, 500);

		ModalActions.open({
			modalId: "help-text-modal",
			description: this.props.helpText
		});
	};

	handleKeyDown(e) {

		if(e.target.tagName === "I" && e.keyCode === 13 || e.keyCode === 32) {
			e.preventDefault();
			e.stopPropagation();
			$(e.target).trigger('click');
			return false;
		}

        if(e.keyCode === 32){
            e.preventDefault();
			e.stopPropagation();
			e.currentTarget.click();
        }
	}

	setAriaCheckedLabel(){
		setTimeout(() => {
			const checked = document.querySelector('#' + this.props.id) ? (document.querySelector('#' + this.props.id).getAttribute('aria-checked') === 'true' ? true : false) : false;
			this.setState({...this.state, isChecked: checked});
		}, 0);
	}

	renderRequiredCharacter() {
		if (this.props.required)
			return <strong className="required">*</strong>
	}

	renderLabelWithHelpText(text) {
		if (this.props.component === "document") {
			return (
				<div className="label-document">
					<label htmlFor={this.props.id} id={`${this.props.id}-${this.props.formId}`} onClick={this.props.onClick} className={this.state.className} aria-disabled={this.props.disabled} data-position="top" data-delay="10" data-tooltip={this.props.label}>
						{this.getLabelWithHelpText(text)}
					</label>
				</div>
			);
		} else if(this.props.component === "checkbox"){
			this.setAriaCheckedLabel();

			return (
				<label 
					htmlFor={this.props.id}
					id={`${this.props.id}-${this.props.formId}`}
					onClick={this.onClick.bind(this)}
					onKeyDown={this.handleKeyDown.bind(this)}
					className={this.state.className + ' checkbox'}
					role={'checkbox'}
					aria-checked={this.state.isChecked}
					aria-disabled={this.props.disabled}
					tabIndex="0"
					data-position="top" data-delay="10" data-tooltip={this.props.label}
				>
					{this.getLabelWithHelpText(text)}
				</label>
			);
		}
		else {
			return (
				<label 
					htmlFor={this.props.id} 
					id={`${this.props.id}-${this.props.formId}`} 
					onClick={this.onClick.bind(this)} 
					aria-disabled={this.props.disabled}
				>
					{this.getLabelWithHelpText(text)}
				</label>					
			);
		}
	}

	getLabelWithHelpText(text){

		setTimeout(() => {
			const self = this;
			$("#" + this.props.id).unbind('focusin').focusin(()=>{
				$(`#${self.props.id}-${this.props.formId}`).find('.tooltipped').attr('aria-hidden', true);
			});

			$("#" + this.props.id).unbind('focusout').focusout(()=>{
				$(`#${self.props.id}-${this.props.formId}`).find('.tooltipped').attr('aria-hidden', false);
			});
		}, 1000);

		return(
			<div style={{ display: 'flex', 'align-items': 'center', width: '100%' }}>
				<span className={`tooltipped`} data-position="top" data-delay="10" data-tooltip={this.props.label}>
					{text}
				</span>
				{this.renderRequiredCharacter()}
				<div role="tooltip" style={{ display: 'inline-block' }}>
					<i onClick={this.showHelpText.bind(this)} tabIndex="0" aria-label={`${Realize.i18n.t('general.button.help_modal')} - ${this.props.helpText}`} className="tiny cursor-help tooltipped" data-position="top" id="icon-help-text-modal" data-delay="10" data-tooltip={Realize.i18n.t('process.helpText')} style={{marginLeft: '0 !important'}}>
						<i className="tiny material-icons cursor-help" aria-hidden={true} style={{top: '1px', marginLeft: '0px'}}>live_help</i>
					</i>
				</div>
			</div>
		);
	}

	onClick(e){
		this.props.onClick(e);
		setTimeout(() => {
			const checked = document.querySelector('#' + this.props.id).getAttribute('aria-checked') === 'true'? true : false;
			this.setState({...this.state, isChecked: checked});
		}, 0);
		this.setAriaCheckedLabel();
	}

	renderDefaultLabel(text) {
		if (this.props.component === "checkbox") {
			this.setAriaCheckedLabel();

			return (
				<label 
					htmlFor={this.props.id}
					id={`${this.props.id}-${this.props.formId}`}
					role={'checkbox'}
					onClick={this.onClick.bind(this)}
					onKeyDown={this.handleKeyDown.bind(this)}
					className={this.state.className}
					aria-checked={this.state.isChecked}
					aria-disabled={this.props.disabled || this.props.readOnly}
					tabIndex="0"
				>
					<span className={`tooltipped`} data-position="top" data-delay="10" data-tooltip={this.props.label}>
						{text}
					</span>
					{this.renderRequiredCharacter()}
				</label>
			);
		}
		
		return (
			<label 
				htmlFor={this.props.id}
				id={`${this.props.id}-${this.props.formId}`}
				onClick={this.props.onClick}
				className={`${this.state.className}`}
				aria-disabled={this.props.disabled}
			>
				<span className={`tooltipped`} data-position="top" data-delay="10" data-tooltip={this.props.label}>
					{text}
				</span>
				{this.renderRequiredCharacter()}
			</label>
		);
	};

	renderLabelHide(){
		const classHide = (this.props.component === 'checkbox' || this.props.component === 'radiobutton') ? '' : 'hide'

		if(this.props.component === 'checkbox'){
			this.setAriaCheckedLabel();

			return (
				<label htmlFor={this.props.id}
					id={`${this.props.id}-${this.props.formId}`}
					onClick={this.onClick.bind(this)}
					onKeyDown={this.handleKeyDown.bind(this)}
					className={this.state.className}
					aria-checked={this.state.isChecked}
					aria-disabled={this.props.disabled || this.props.readOnly}
					role={'checkbox'}
					tabIndex="0">
					<span className="hide">{'.'}</span>
					{this.renderRequiredCharacter()}
				</label>
			);
		}

		return(
			<label htmlFor={this.props.id} id={`${this.props.id}-${this.props.formId}`} onClick={this.props.onClick} className={`${this.state.className} ${classHide}`} tabIndex="0" aria-disabled={this.props.disabled}>
				<span className="hide">{'.'}</span>
				{this.renderRequiredCharacter()}
			</label>
		);
	}

	renderLabel(text) {

		// if(text.trim() === ''){
		// 	return this.renderLabelHide();
		// }

		return !!this.props.helpText
			? this.renderLabelWithHelpText(text)
			: this.renderDefaultLabel(text);
	};

	render() {
		const labelProp = this.props.label;

		if(typeof(labelProp) == "boolean" && !labelProp) {
			return <span />;
		}

		let text = (labelProp !== undefined && labelProp !== null) ? String(labelProp) : '';

		return this.renderLabel(text);
	};
}
